module.exports = __webpack_public_path__ + "static/media/odd3.c6480b7e.jpg";